import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AlertsSliceState } from "../types";
import { TagColorMap } from "../utils/const";

const defaultCheckedList = ["Info", "Danger", "Warning"];

const initialState: AlertsSliceState = {
  page: 0,
  pageSize: 100,
  deviceUuids: [],
  tags: Object.keys(TagColorMap),
  levels: defaultCheckedList,
  buildEnv: process.env.REACT_APP_ENV || "production",
};

const alertsSlice = createSlice({
  name: "alerts",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<AlertsSliceState>>) => {
      return { ...state, ...action.payload };
    },
    resetFilters: () => initialState,
  },
});

export const { setFilters, resetFilters } = alertsSlice.actions;
export default alertsSlice.reducer;
